import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const Annuities: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon
      fill={fill}
      height={height}
      viewBox="0 0 70 70"
      width={width}
      {...rest}
    >
      <path
        d="M5 15.17C5 11.21 14.6 8 26.45 8C38.3 8 47.9 11.21 47.9 15.17"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M5 15.17C5 11.21 14.6 8 26.45 8C38.3 8 47.9 11.21 47.9 15.17"
        stroke="#424242"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#ffffff"
      />
      <path
        d="M5 15.17V51.13C5 51.13 8.46 58.3 28 58.3C47.54 58.3 47.89 51.13 47.89 51.13V15.17"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M5 15.17V51.13C5 51.13 8.46 58.3 28 58.3C47.54 58.3 47.89 51.13 47.89 51.13V15.17"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#424242"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 26.18C12.35 29.4 27.82 33.78 47.77 26.21"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#424242"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 16.83C12.35 20.05 27.82 24.43 47.77 16.86"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#424242"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 35.86C12.35 39.08 27.82 43.46 47.77 35.89"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#424242"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 44.7C10.57 48.39 27.82 53.14 47.77 45.57"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#424242"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.48 61.72C57.9734 61.72 66.48 53.2134 66.48 42.72C66.48 32.2266 57.9734 23.72 47.48 23.72C36.9866 23.72 28.48 32.2266 28.48 42.72C28.48 53.2134 36.9866 61.72 47.48 61.72Z"
        fill="#ffffff"
        stroke="#424242"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.18 45.35L55.94 47.66C55.69 48.95 55.14 49.91 54.28 50.54C53.42 51.17 52.22 51.48 50.68 51.48H41.44V47.84C42.25 47.84 42.87 47.65 43.3 47.28C43.72 46.91 43.94 46.38 43.94 45.69C43.94 45.55 43.94 45.4 43.91 45.25C43.89 45.1 43.87 44.9 43.83 44.65H41.57V42.34H42.84C42.5 41.68 42.27 41.13 42.15 40.67C42.03 40.21 41.96 39.74 41.96 39.26C41.96 37.58 42.58 36.19 43.83 35.08C45.08 33.97 46.67 33.42 48.62 33.42C50.57 33.42 52.02 33.92 53.13 34.92C54.25 35.92 54.8 37.22 54.8 38.84C54.8 39.34 54.72 39.82 54.57 40.3C54.42 40.78 54.19 41.22 53.89 41.63L50.31 40.3C50.47 40.07 50.58 39.84 50.65 39.61C50.72 39.38 50.76 39.15 50.76 38.92C50.76 38.28 50.57 37.77 50.19 37.39C49.81 37.01 49.3 36.82 48.66 36.82C47.97 36.82 47.41 37.05 46.99 37.51C46.57 37.97 46.35 38.57 46.35 39.32C46.35 39.71 46.39 40.09 46.47 40.45C46.55 40.81 46.78 41.45 47.17 42.35H50.22V44.66H47.75C47.77 44.71 47.78 44.77 47.78 44.83V45.11C47.78 45.62 47.59 46.14 47.2 46.66C46.81 47.18 46.33 47.58 45.77 47.84H50.26C51.16 47.84 51.84 47.65 52.3 47.26C52.76 46.87 53.04 46.23 53.15 45.35H53.18Z"
        fill="#E81C30"
      />
    </Icon>
  )
}
